<template>
  <div class="sub_account_box">
    <p style="font-size: 16px;font-weight: bold;font-family: '苹方';margin-bottom: 12px;">
      {{ $t('center.Sub_account_management') }}</p>
    <div class="add_new_con">
      <b2b-button style="width: 180px;height: 40px;line-height: 40px;" @click="addSunAccountDialogShow = true">
        {{ $t('center.Add_sub_account') }}
      </b2b-button>
    </div>

    <div class="con_data_box">
      <el-table :data="accountData" style="width: 100%">
        <el-table-column prop="name" :label="$t('center.Employee_name')" width="180">
        </el-table-column>
        <el-table-column prop="email" :label="$t('booking.email')" width="220">
        </el-table-column>
        <el-table-column prop="mobile" :label="$t('booking.phone_number')" width="180">
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template v-slot="scope">
            <el-switch v-model="scope.row.status" :active-value="0" :inactive-value="1"
                       @change="event => changeStatus(event, scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column :label="$t('center.operation')">
          <template v-slot="scoped">
            <div class="btn_group">
               <span class="primary_btn"
                     @click="editUser(scoped.row)">修改</span>
              <span class="primary_btn"
                    @click="editAccountPermission(scoped.row)">权限</span>
              <span class="primary_btn" @click="delContact(scoped.row)">
                {{$t('center.delete') }}
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog :title="$t('center.Add_sub_account')" :visible.sync="addSunAccountDialogShow" width="30%"
      :close-on-click-modal="false" @close="closeDialog">
      <div>
        <el-form ref="subAccountForm" label-position="top" :model="subAccountForm" style="width: 65%;" :rules="rules">
          <el-form-item :label="$t('booking.name')" prop="name">
            <el-input v-model="subAccountForm.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('booking.phone_number')" prop="mobile">
            <template v-slot:label>
              <span>手机</span>
              <span style="margin-left: 8px;font-size: 12px;color: grey">用于子账号登录</span>
            </template>
            <el-input v-model="subAccountForm.mobile"></el-input>
          </el-form-item>
          <el-form-item :label="$t('booking.email')" prop="email">
            <el-input v-model="subAccountForm.email"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input @focus="focusMyInput" @blur="blurMyInput"
                      type="text" v-model="subAccountForm.password" :showPassword="isShowPassword" autocomplete="new-password"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="addSunAccountDialogShow = false">{{ this.$t('header.cancel') }}</el-button>
            <el-button type="primary" @click="toAdd">{{ this.$t('center.save') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <el-dialog title="编辑子账号" :visible.sync="updateSunAccountDialogShow" width="30%"
               :close-on-click-modal="false">
      <div>
        <el-form ref="updateSubAccountForm" label-position="top" :model="currUser" style="width: 65%;" :rules="rules">
          <el-form-item :label="$t('booking.name')" prop="name">
            <el-input v-model="currUser.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('booking.phone_number')" prop="mobile">
            <template v-slot:label>
              <span>手机</span>
              <span style="margin-left: 8px;font-size: 12px;color: grey">用于子账号登录</span>
            </template>
            <el-input v-model="currUser.mobile"></el-input>
          </el-form-item>
          <el-form-item :label="$t('booking.email')" prop="email">
            <el-input v-model="currUser.email"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input v-model="currUser.password" show-password></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="updateSunAccountDialogShow = false">{{ this.$t('header.cancel') }}</el-button>
            <el-button type="primary" @click="toUpdate">{{ this.$t('center.save') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <el-dialog title="子账号权限管理" :visible.sync="accountPermissionDialog" width="600px">
      <div class="account_setting">
        <div class="account_setting_item">
          <span class="account_setting_title">酒店预定权限</span>
          <el-checkbox v-model="currAccountPermission.booking">酒店预定</el-checkbox>
          <el-checkbox v-model="currAccountPermission.allowCredit">允许额度支付</el-checkbox>
        </div>
        <div class="account_setting_item">
          <span class="account_setting_title">订单权限</span>
          <el-radio-group v-model="currAccountPermission.allOrder">
            <el-radio :label="false">允许查看本人订单</el-radio>
            <el-radio :label="true">允许查看所有订单</el-radio>
          </el-radio-group>
        </div>
        <div class="account_setting_item">
          <span class="account_setting_title">酒店账单权限</span>
          <el-checkbox v-model="currAccountPermission.hotelBill">查询酒店账单信息</el-checkbox>
        </div>
        <div class="account_setting_item">
          <span class="account_setting_title">额度明细权限</span>
          <el-radio-group v-model="currAccountPermission.allBill">
            <el-radio :label="false">查看本人额度明细</el-radio>
            <el-radio :label="true">查看所有额度明细</el-radio>
          </el-radio-group>
        </div>
        <div class="account_setting_item">
          <span class="account_setting_title">账户信息权限</span>
          <el-checkbox v-model="currAccountPermission.accountInfo">查询账户信息</el-checkbox>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="accountPermissionDialog = false">取 消</el-button>
        <el-button type="primary" @click="updateAccountPermission">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      accountData: [],
      addSunAccountDialogShow: false,
      subAccountForm: {},
      rules: {
        name: [
          { required: true, message: this.$t('register.enter_name'), trigger: 'blur' },
        ],
        email: [
          { required: true, message: this.$t('register.enter_mailbox'), trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: this.$t('center.mailbox_format'), trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: this.$t('register.enter_phone_number'), trigger: 'blur' },
          { pattern: /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/, message: this.$t('center.phone_formatter'), trigger: 'blur' }
        ],
        password: [
          { min: 6, message: '密码长度最小为6位', trigger: 'blur' }
        ]
      },
      accountPermissionDialog: false,
      currAccountPermission: {},
      currUser: {},
      updateSunAccountDialogShow: false,
      isShowPassword: false
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      const { data: result } = await this.$http.get('/mini/getAccount', {
        headers: { accessToken: this.$common.isLogin() ? JSON.parse(this.$common.isLogin()).token : '' }
      })
      if (!result.success) return this.$message.error(result.message)
      this.accountData = result.data
    },
    focusMyInput () {
      this.isShowPassword = true
    },
    blurMyInput () {
      this.isShowPassword = false
    },
    toAdd () {
      this.$refs['subAccountForm'].validate(async (valid) => {
        if (valid) {
          const { data: result } = await this.$http.post('/mini/addAccount', this.subAccountForm, {
            headers: { accessToken: this.$common.isLogin() ? JSON.parse(this.$common.isLogin()).token : '' }
          })
          if (result.code != 200) return this.$message.error(result.message)
          this.$message.success(this.$t('center.Successfully_added'))
          this.addSunAccountDialogShow = false
          this.init()
        }
      })
    },
    toUpdate () {
      this.$refs['updateSubAccountForm'].validate(async (valid) => {
        if (valid) {
          const { data: result } = await this.$http.post('/mini/updateAccount', this.currUser, {
            headers: { accessToken: this.$common.isLogin() ? JSON.parse(this.$common.isLogin()).token : '' }
          })
          if (result.code !== 200) return this.$message.error(result.message)
          this.$message.success(this.$t('center.Successfully_added'))
          this.updateSunAccountDialogShow = false
          await this.init()
        }
      })
    },
    delContact (e) {
      this.$confirm(this.$t('center.del_emp'), this.$t('header.Reminder'), {
        confirmButtonText: this.$t('header.confirm'),
        cancelButtonText: this.$t('header.cancel'),
        type: 'warning'
      }).then(async () => {
        const { data: result } = await this.$http.post(`/mini/delAccount`, e, {
          headers: { accessToken: this.$common.isLogin() ? JSON.parse(this.$common.isLogin()).token : '' }
        })
        if (!result.success) return this.$message.error(result.message)
        this.$message.success(this.$t('center.Delete_succeeded'))
        this.init()
      }).catch(() => {

      });
    },
    editAccountPermission (account) {
      this.currAccountPermission = JSON.parse(account.accountPermission)
      this.currAccountPermission.accountId = account.accountId
      this.accountPermissionDialog = true
    },
    editUser (row) {
      this.currUser = {...row}
      this.currUser.password = ''
      this.updateSunAccountDialogShow = true
    },
    async updateAccountPermission () {
      let headers = { accessToken: this.$common.isLogin() ? JSON.parse(this.$common.isLogin()).token : '' }
      const {data: result} = await this.$http.post('/mini/updateAccountPermission', this.currAccountPermission, {headers})
      if (!result.success) return this.$message.error(result.message)
      await this.init()
      this.accountPermissionDialog = false
      this.$message.success('保存成功')
    },
    async changeStatus (e, account) {
      let headers = { accessToken: this.$common.isLogin() ? JSON.parse(this.$common.isLogin()).token : '' }
      const {data: result} = await this.$http.get(`/mini/updateAccountStatus?accountId=${account.accountId}&status=${e}`, {headers})
      if (!result.success) return this.$message.error(result.message)
      await this.init()
      this.$message.success('操作成功')
    },
    closeDialog () {
      this.subAccountForm = {}
      this.$refs['subAccountForm'].resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
.sub_account_box {
  min-height: 325px;
  padding: 20px;
  background-color: #fff;
}

.add_new_con {
  display: flex;
  justify-content: right;
}

.con_data_box {
  margin-top: 20px;
}

/deep/.el-table th,
.el-table tr {
  background-color: #f7f7f7;
  font-size: 13px;
}

/deep/.el-dialog__header {
  background-color: #fff;
}

/deep/.el-dialog__title {
  color: #303133;
}

/deep/.el-form--label-top .el-form-item__label {
  padding: 0;
}

/deep/.el-form-item__label {
  height: 30px;
  line-height: 30px;
}

/deep/.el-dialog__body {
  padding: 0 20px;
}

/deep/.el-table td,
.el-table th {
  font-size: 13px;
}

.btn_group {
  display: flex;
  column-gap: 10px;
  align-items: center;

  .primary_btn {
    color:#1e50f0;
    cursor: pointer;
    user-select: none;
  }
}

.account_setting {
  &_item {
    display: flex;
    align-items: center;
    column-gap: 25px;
    margin-bottom: 25px;
  }

  &_title {
    width: 95px;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/order/SubAccount.vue